<template>
  <v-app id="app">
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="$store.state.token"
      style="transition:none !important;"
    >
      <template v-slot:prepend>
        <router-link to="/" style="margin:0 auto;">
          <v-img
            src="./assets/logo.png"
            :max-height="40"
            contain
            class="my-2"
          />
        </router-link>
      </template>
        

      <v-list 
        dense 
        nav
      >
        <div
                v-for="(item, idx) in items"
                :key="item.title"
                no-action
                class="my-1"
                :ripple="false"
                color=""
        >
          <v-divider class="my-2" v-if="idx !== 0"/>

          <v-list-item>
            <v-list-item-subtitle class="text-caption">
              {{ item.title }}
            </v-list-item-subtitle>
         </v-list-item>

          <v-list-item
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  :to="subItem.link"
                  link
                  :ripple="false"
          >
            <v-list-item-icon>
              <v-icon dense>{{ subItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="subItem.title"/>
            </v-list-item-content>

          </v-list-item>


        </div>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="#FFFFFF"
      flat
      dense
      v-if="$store.state.token"
      style="transition:none !important;"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      {{ pageTitle }}
      
      <v-spacer />
      <!--<v-btn @click="send">테스트</v-btn>-->
      <v-btn text @click="logInAndOut">{{logInfo}}</v-btn>
    </v-app-bar>

    <v-main class="ma-4"  style="transition:none !important;">
        <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import store from './store/index'
export default {
  name: 'App',

  components: {
  },

  data: () => ({
    drawer: null,
    alerts: 0,
    userId: '',
    pageTitle:'',
    items: [
    {
        action: 'mdi-monitor',
        title: '모니터링',
        active: false,
        items: [
          { title: '대시보드', link: '/', icon:'mdi-view-dashboard-outline', },
          { title: '센서데이터', link: '/sensor', icon:'mdi-access-point' },
        ]
      },
      {
        action: 'mdi-file-document-edit-outline',
        title: '기준정보',
        active: false,
        items: [
          { title: '조직정보', link: '/OrganizationMaster', icon:'mdi-office-building-outline' },
          { title: '제품정보', link: '/ProductionMaster', icon:'mdi-package-variant' },
          { title: '설비정보', link: '/EquipmentMaster', icon:'mdi-robot-industrial' },
          { title: '고객정보', link: '/CustomerMaster', icon:'mdi-card-account-details-outline' },
          { title: 'SPC기준정보', link: '/SPCMaster', icon:'mdi-chart-bell-curve-cumulative' }
        ]
      },
      {
        action: 'mdi-chart-multiple',
        title: 'SPC',
        active: false,
        items: [
          // { title: '데이터 입력', link: '/SPCDataInput', icon:'mdi-pencil-outline' },
          // { title: 'X-MR 관리도', link: '/XMRSearch', icon:'mdi-chart-bell-curve' },
          { title: 'XMR 관리도', link: '/XMRSearch', icon:'mdi-chart-bell-curve' },
          // { title: 'X̅ -S 관리도', link: '/XbarSSearch', icon:'mdi-chart-bell-curve' },
          { title: '이상발생 관리 목록', link: '/AnomalyList', icon:'mdi-alert-circle-outline' },
        ]
      }
      ]
  }),
  computed: {
    isAuthenticated() {
      return (store.state.token !== null)
    },
    logInfo() {
      return this.isAuthenticated ? '로그아웃' : '로그인'
    }
  },
  created () {
    // QPC 옵션.
    if (this.$Define.QPC) {
      this.items.push(
        {
          action: 'mdi-desktop-mac-dashboard',
          title: 'QPC',
          active: false,
          items: [
            { title: '수입검사', link: '/IncomingInspection' },
            { title: '공정검사', link: '/InprocessInspection' },
            { title: '출하검사', link: '/OutgoingInspection' },
            { title: '공정능력', link: '/ProcessCapability' },
            { title: 'KPI', link: '/KPIIndicator' }
          ]
        }
      )
    }
    // 로딩 이벤트 처리.
    this.$eventBus.$on('loading', function (value) {
      if (value === true) {
        this.isLoading = true
      } else {
        this.isLoading = false
      }
    }.bind(this))
  },
  methods: {
    logInAndOut(){
      if (this.isAuthenticated) {
        this.$store.dispatch('logout')
        if (this.$Common.socket !== null) {
          console.log('소켓 연결 종료')
          this.$Common.socket.close()
        }
        this.$router.push('/login')
      } else {
        this.$router.push('/login')
      }
    },
    send() {
      if (this.$Common.stompClient && this.$Common.stompClient.connected) {
        const msg = { 
          tags:[{
            accelX:-0.004,
            accelY:0.096,
            accelZ:1.02,
            createDate:'2020-11-24T10:23:26',
            dataFormat:5,
            defaultBackground:5,
            favorite:true,
            humidity:Math.random() * (10) + 25,
            humidityOffset:0.0,
            id:'C7:63:B1:6E:7E:8B',
            measurementSequenceNumber:7176,
            movementCounter:63,
            pressure:101924.0,
            rssi:-51,
            temperature:Math.random() * (10) + 5,
            txPower:4.0,
            updateAt:'2020-11-24T12:54:00',
            voltage:3.157
          }],
          batteryLevel:46,
          deviceId:'1rpboa6n2jftn-18e66jsaehvck',
          eventId:'28b290a1-a322-4a7f-bdbf-d61e039322bb',
          location:{
            accuracy:13.517,
            latitude:35.1910549,
            longitude:128.9846267
          },
          time:'2020-11-24T12:54:00'
        }
        this.$axios.post("/app/ruuvi", msg, this.$Common.headerApiRequest())
        .then((res)=>{
          console.log(res)
        })
        .catch((err)=>{
          console.log(err)
        })
      }
    },
  },
  watch:{
    '$route'() {
      let find = false
      for(let i = 0; i < this.items.length; i++) {
        for(let j = 0; j < this.items[i].items.length; j++) {
          if(this.$route.path === this.items[i].items[j].link) {
            this.pageTitle = this.items[i].items[j].title
            find = true
            break
          }
        }
        if(find) {
          break
        }
      }
    }
  }
};
</script>
<style lang="scss">
  @import '@/scss/common.scss';

  .v-navigation-drawer__border {
      display:none;
  }
  nav {
    box-shadow: 0 2px 10px -1px rgba(85,85,85,.08),0 1px 10px 0 rgba(85,85,85,.06),0 1px 30px 0 rgba(85,85,85,.03)!important;
  }

</style>
